<template>
  <div>
    <Niches />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Niches from '@/components/Niches';

export default {
  nuxtI18n: {
    paths: {
      en: '/topics',
      de: '/themen',
      es: '/topicos',
      pt: '/topics'
    }
  },
  components: {
    Niches
  },
  async fetch({ store }) {
    await Promise.all([
      store.dispatch('niches/LOAD_NICHES'),
      store.dispatch('listings/GET_LIST', {
        name: 'featured_niches',
        type: 'topics',
        exp: store.getters['experience/getDesign']
      })
    ]);
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('experience', ['getDesign'])
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.8em;
}
</style>
